import React from 'react'
import PropTypes from 'prop-types'

// Import all template components
import ProfessionalTemplate from '../templates/ProfessionalTemplate'
import ServicesTemplate from '../templates/ServicesTemplate'
import LandingTemplate from '../templates/LandingTemplate'
import CatalogTemplate from '../templates/CatalogTemplate'

const templateComponents = {
  'ProfessionalTemplate': ProfessionalTemplate,
  'ServicesTemplate': ServicesTemplate,
  'LandingTemplate': LandingTemplate,
  'CatalogTemplate': CatalogTemplate,
}

function TemplateRenderer({ templateId, vCard, className = '' }) {
  // Find the template by ID
  const template = getTemplateById(templateId)
  
  if (!template) {
    return <div className="text-center text-gray-500">Plantilla no encontrada</div>
  }

  // Get the component based on the template's componentRef
  const TemplateComponent = templateComponents[template.componentRef]
  
  if (!TemplateComponent) {
    return <div className="text-center text-gray-500">Componente de plantilla no disponible</div>
  }

  return (
    <div className={`template-renderer ${className}`}>
      <TemplateComponent vCard={vCard} template={template} />
    </div>
  )
}

// Mock function to get template by ID - in real app this would come from store/props
function getTemplateById(templateId) {
  const mockTemplates = [
    {
      id: 'template-1',
      name: 'Presentación Profesional',
      type: 'presentation',
      componentRef: 'ProfessionalTemplate',
      previewUrl: 'https://via.placeholder.com/400x600/2563eb/ffffff?text=Professional',
      description: 'Diseño minimalista ideal para ejecutivos y freelancers',
      features: ['Diseño limpio', 'Foto de perfil', 'Redes sociales', 'Contacto directo'],
      isActive: true,
    },
    {
      id: 'template-2',
      name: 'Servicios Premium',
      type: 'services',
      componentRef: 'ServicesTemplate',
      previewUrl: 'https://via.placeholder.com/400x600/10b981/ffffff?text=Services',
      description: 'Perfecto para profesionales de servicios',
      features: ['Lista de servicios', 'Precios', 'Citas online', 'Testimonios'],
      isActive: true,
    },
    {
      id: 'template-3',
      name: 'Landing Personal',
      type: 'landing',
      componentRef: 'LandingTemplate',
      previewUrl: 'https://via.placeholder.com/400x600/f59e0b/ffffff?text=Landing',
      description: 'One-page completa con todos tus datos',
      features: ['Hero section', 'Galería', 'Formulario contacto', 'Animaciones'],
      isActive: true,
    },
    {
      id: 'template-4',
      name: 'Catálogo de Productos',
      type: 'catalog',
      componentRef: 'CatalogTemplate',
      previewUrl: 'https://via.placeholder.com/400x600/ec4899/ffffff?text=Catalog',
      description: 'Ideal para negocios con productos',
      features: ['Grid de productos', 'Carrito', 'Pasarela pago', 'Inventario'],
      isActive: true,
    },
  ]
  
  return mockTemplates.find(t => t.id === templateId)
}

TemplateRenderer.propTypes = {
  templateId: PropTypes.string.isRequired,
  vCard: PropTypes.object.isRequired,
  className: PropTypes.string,
}

export default TemplateRenderer